import LegacyPublicationSectionRecord from "models/view-models/legacy-publication-section-record";
import { useCallback, useEffect } from "react";
import useServiceHookResultState from "utilities/hooks/use-service-hook-result-state";
import ServiceHookResult from "utilities/interfaces/service-hook-result";
import LegacyPublicationSectionService from "utilities/services/legacy-publication-sections/legacy-publication-section-service";

interface UseLegacyPublicationSectionOptions {
    sectionId?: number;
}

export default function useLegacyPublicationSection(
    options: UseLegacyPublicationSectionOptions
): ServiceHookResult<LegacyPublicationSectionRecord | undefined> {
    const { sectionId } = options;
    const { list: listSections } =
        LegacyPublicationSectionService.useBatchList();

    const { result, setError, setInitial, setLoading, setSuccess } =
        useServiceHookResultState<LegacyPublicationSectionRecord | undefined>(
            undefined
        );

    const loadSection = useCallback(async () => {
        if (sectionId == null) {
            setInitial();
            return;
        }

        setLoading();

        try {
            const { resultObjects: sections } = await listSections(
                { legacyPublicationSectionIds: [sectionId] },
                "legacyPublicationSectionIds",
                1
            );

            const section = sections?.at(0);
            if (section != null) {
                setSuccess(section);
            } else {
                setInitial();
            }
        } catch (error) {
            setError(error);
        }
    }, [sectionId, listSections, setError, setInitial, setLoading, setSuccess]);

    useEffect(() => {
        loadSection();
    }, [loadSection]);

    return { ...result };
}
